import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { LOGO } from '../data/assets';
import { adminLogin } from '../lib/api';
import { useToast } from '../hooks/use-toast';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      localStorage.setItem('nl_admin_token', token);
      navigate('/admin/dashboard');
    } catch (err) {
      toast({ title: 'Login failed', description: 'Incorrect password.', variant: 'destructive' });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 section-soft">
      <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 w-full max-w-md">
        <img src={LOGO} alt="National Light" className="h-14 mx-auto mb-6" />
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#eaf6ec] flex items-center justify-center mx-auto mb-3"><Lock size={24} className="text-[#0f7a37]" /></div>
          <h1 className="font-head text-2xl font-extrabold text-[#14181b]">Admin Dashboard</h1>
          <p className="text-sm text-gray-500 mt-1">Manage products & orders</p>
        </div>
        <form onSubmit={submit}>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter admin password"
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 outline-none focus:border-[#0f7a37] mb-4" autoFocus />
          <button type="submit" disabled={loading}
            className="nl-btn w-full bg-[#0f7a37] hover:bg-[#0d5228] text-white py-3 disabled:opacity-60">
            <LogIn size={18} /> {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p className="text-center text-xs text-gray-400 mt-4">Default password: <span className="font-mono font-semibold">national123</span></p>
      </div>
    </div>
  );
};

export default AdminLogin;
